exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.info-box[data-v-07c5e6ed] {\n    background-color: #f8f9fa;\n    padding: 15px;\n    border-radius: 4px;\n    margin-bottom: 20px;\n}\n.default-box[data-v-07c5e6ed] {\n    border: darkgray solid 1px;\n    padding: 15px;\n    border-radius: 4px;\n    margin-bottom: 20px;\n}\n.btn-primary[data-v-07c5e6ed] {\n    background: #451493 !important;\n    border-color: #451493 !important;\n}\n.btn-primary[data-v-07c5e6ed]:hover {\n    color: #fff !important;\n    background-color: #350f71 !important;\n    border-color: #300e66 !important;\n}\n", ""]);

// exports
